var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 576,
    viewBox: "0 0 510 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.833 339.301h-84.689a4.138 4.138 0 00-4.144 4.132v84.421c0 3.682 4.469 5.532 7.081 2.928l84.689-84.422c2.613-2.604.757-7.059-2.937-7.059zM194.109 144h87.05c47.227 0 85.572 38.223 85.572 85.32 0 47.078-38.345 85.319-85.59 85.319H172.883a4.12 4.12 0 01-4.126-4.113V169.273C168.739 155.334 180.109 144 194.109 144z",
    fill: "#0063FF"
  })));
}
export default SvgPpIcon;